/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems model module.
 * @module model/AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems
 * @version v0.3
 */
export default class AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems {
  /**
   * Constructs a new <code>AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems</code>.
   * @alias module:model/AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems} obj Optional instance to populate.
   * @return {module:model/AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems} The populated <code>AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AnyOfworkflowsPersonalizationRuleSetNodesTargetsItems();
    }
    return obj;
  }
}
